// extracted by mini-css-extract-plugin
export default {"avatar":"WalletAvatar-module__avatar","imageWrapper":"WalletAvatar-module__imageWrapper","image":"WalletAvatar-module__image"};